<!-- TODO 图片-->
<template>
    <div class="edit_wrap">
        <!-- tab -->
        <div class="add_top">
            <div class="add_tab active_tab">品牌详情</div>
        </div>

        <!-- 品牌详情 -->
        <div class="choice_brand mt20 mb20">
            <!-- 中英文名称 -->
            <div class="add_name">
                <div class="c_name">
                    <!-- <span class="main_word mr4">*</span> -->
                    <span class="form_color">品牌中文名称：</span>
                    <span class="f999 f12">{{brandDetail.brandName}}</span>
                </div>
                <div class="e_name">
                    <!-- <span class="main_word mr4">*</span> -->
                    <span class="form_color">品牌英文名称：</span>
                    <span class="f999 f12">{{brandDetail.brandEnname}}</span>
                </div>
            </div>
            <!-- 信息验证 -->
            <el-form :model="brandDetail" label-width="207px" class="demo-ruleForm">
                <el-form-item label="品类合作类型：">
                    <el-checkbox-group class="dib vtb ml_10" v-model="categoryType">
                        <el-checkbox label="1" disabled>图书类</el-checkbox>
                        <el-checkbox label="2" disabled>非图书类</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>

                <el-form-item label="品牌合作品类：">
                </el-form-item>

                <el-form-item label-width="60px">
                    <template scope="scope" v-if="brandDetail.categories && brandDetail.categories.length > 0">
                        <el-table :data="brandDetail.categories" border style="width: 92%;margin: 0 auto;">
                            <el-table-column label="主营品类"
                                             width="200"
                                             align="center">
                                <template scope="scope">
                                    <span>{{ scope.row.category.grandName }}--</span>
                                    <span>{{ scope.row.category.parentName }}--</span>
                                    <span>{{ scope.row.category.childrenName }}</span>
                                </template>
                            </el-table-column>

                            <el-table-column label="是否提供发票"
                                             width="140"
                                             align="center">
                                <template scope="scope">
                                    <span v-if="scope.row.provideInvoice==0">否</span>
                                    <span v-if="scope.row.provideInvoice==1">是</span>
                                </template>
                            </el-table-column>

                            <el-table-column label="发票类型" align="center" width="180">
                                <template scope="scope">
                                    <span v-if="scope.row.provideInvoice==0">无</span>
                                    <span v-if="scope.row.provideInvoice==1 && registeredCountry == 1 && scope.row.invoiceType == 1">增值税普通发票</span>
                                    <span v-if="scope.row.provideInvoice==1 && taxpayerType==1 && registeredCountry == 1 && scope.row.invoiceType == 2">增值税专用发票</span>
                                    <span v-if="scope.row.provideInvoice==1 && taxpayerType==2 && registeredCountry == 1 && scope.row.invoiceType == 2">增值税专用发票（需去税务局代开）</span>
                                    <span v-if="scope.row.provideInvoice==1 && registeredCountry != 1 && scope.row.invoiceType == 3">形式发票</span>
                                </template>
                            </el-table-column>

                            <el-table-column label="税率" align="center" min-width="150">
                                <template scope="scope">
                                    <span v-if="scope.row.rates.length==0">无</span>
                                    <span v-if="scope.row.rates.length>0" v-for="rateValue in scope.row.rates">
                                    {{rateValue}}%
                                    </span>
                                </template>
                            </el-table-column>

                            <el-table-column width="200" label="品类经营特许资质电子版" align="center">
                                <template scope="scope" >
                                    <img v-if="scope.row.franchiseQualification == 1" @click="previewPic($event)"
                                         class="pic_skan" :src="scope.row.franchiseQualificationFile">
                                    <span v-if="!scope.row.franchiseQualification == 1">不需要</span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </template>
                </el-form-item>

                <div v-if="brandDetail.categoryNotBook == 1">
                    <!-- 商品是否进口 -->
                    <el-form-item label="商品是否进口：">
                        <span v-if="brandDetail.goodsType == 1" class="f999">非进口</span>
                        <span v-if="brandDetail.goodsType == 2" class="f999">进口</span>
                    </el-form-item>

                    <!-- 品牌经营方式 -->
                    <el-form-item label="品牌经营方式：">
                        <span v-if="brandDetail.businessType == 1" class="f999">自有品牌</span>
                        <span v-if="brandDetail.businessType == 2" class="f999">代理商</span>
                        <span v-if="brandDetail.businessType == 3" class="f999">其他</span>
                        <span v-if="brandDetail.businessType == 4" class="f999">课程</span>
                    </el-form-item>
                    <!-- 商标注册证电子版 -->
                    <el-form-item v-if="brandDetail.businessType == 1 || brandDetail.businessType == 2"
                                  label="商标注册证电子版：">
                        <div>
                            <template v-if="brandDetail.trademarkRegistrationCertificateFiles && brandDetail.trademarkRegistrationCertificateFiles.length>0 ">
                                <img v-if="brandDetail.trademarkRegistrationCertificateFiles" @click="previewPic($event)" v-for="(rcFile, index) in brandDetail.trademarkRegistrationCertificateFiles"
                                     class="pic_skan" :src="rcFile">
                            </template>
                        </div>
                    </el-form-item>
                    <!-- 完整授权链证书电子版 -->
                    <el-form-item v-if="brandDetail.businessType == 1 || brandDetail.businessType == 2"
                                  label="完整授权链证书电子版：">
                        <div>
                            <template v-if="brandDetail.authCertificateFiles && brandDetail.authCertificateFiles.length>0 ">
                                <img v-if="brandDetail.authCertificateFiles" @click="previewPic($event)" v-for="(rcFile, index) in brandDetail.authCertificateFiles"
                                     class="pic_skan" :src="rcFile">
                            </template>
                        </div>
                    </el-form-item>
                    <!-- 订货单电子版 -->
                    <el-form-item v-if="brandDetail.businessType == 3" label="订货单电子版：" prop="purchaseOrderFile">
                        <div>
                            <template v-if="brandDetail.purchaseOrderFiles && brandDetail.purchaseOrderFiles.length>0 ">
                                <img v-if="brandDetail.purchaseOrderFiles" @click="previewPic($event)" v-for="(rcFile, index) in brandDetail.purchaseOrderFiles"
                                     class="pic_skan" :src="rcFile">
                            </template>
                        </div>
                    </el-form-item>
                    <!-- 报关单扫描件 -->
                    <el-form-item v-if="brandDetail.goodsType == 2" v-show="brandDetail.customsDeclarationFormFiles.length > 0" label="报关单扫描件：" prop="customsDeclarationFormFiles">
                        <div>
                            <template v-if="brandDetail.customsDeclarationFormFiles && brandDetail.customsDeclarationFormFiles.length>0 ">
                                <img v-if="brandDetail.customsDeclarationFormFiles" @click="previewPic($event)" v-for="(rcFile, index) in brandDetail.customsDeclarationFormFiles"
                                     class="pic_skan" :src="rcFile">
                            </template>
                        </div>
                    </el-form-item>
                    <!-- 质检单电子版 -->
                    <el-form-item
                            v-if="brandDetail.registeredCountry==1 && brandDetail.goodsType == 1 && (brandDetail.businessType == 1 || brandDetail.businessType == 2)"
                            label="质检单电子版：" prop="qualityInspectionFiles">
                        <div>
                            <template v-if="brandDetail.qualityInspectionFiles && brandDetail.qualityInspectionFiles.length>0 ">
                                <img v-if="brandDetail.qualityInspectionFiles" @click="previewPic($event)" v-for="(rcFile, index) in brandDetail.qualityInspectionFiles"
                                     class="pic_skan" :src="rcFile">
                            </template>
                        </div>
                    </el-form-item>
                    <!-- 入境货物检验检疫证明 -->
                    <el-form-item v-if="brandDetail.goodsType == 2" v-show="brandDetail.inspectionQuarantineFiles.length > 0" label="入境货物检验检疫证明：" class="dib"
                                  prop="inspectionQuarantineFiles">
                        <div>
                            <template v-if="brandDetail.inspectionQuarantineFiles && brandDetail.inspectionQuarantineFiles.length>0 ">
                                <img v-if="brandDetail.inspectionQuarantineFiles" @click="previewPic($event)" v-for="(rcFile, index) in brandDetail.inspectionQuarantineFiles"
                                     class="pic_skan" :src="rcFile">
                            </template>
                        </div>
                    </el-form-item>
                    <!-- 质检日期 -->
                    <el-form-item
                            v-if="brandDetail.registeredCountry==1 && brandDetail.goodsType == 1 && (brandDetail.businessType == 1 || brandDetail.businessType == 2)"
                            label="质检日期：">
                        <span v-if="brandDetail.qualityInspectionTime" class="f999">{{ brandDetail.qualityInspectionTime | time }}</span>
                    </el-form-item>
                </div>
            </el-form>
            <!-- 保存 -->
            <div align="center" class="mt20 mb20">
                <el-button type="primary" @click="reback()">返回</el-button>
            </div>
            <!--预览图片-->
            <el-dialog :visible.sync="dialogVisible" size="small">
                <img  width="100%" :src="dialogImageUrl" alt="">
            </el-dialog>
        </div>
    </div>
</template>

<script type="text/javascript">
    export default {
        data () {
            return {
                // 预览图片
                dialogImageUrl: '',
                dialogVisible: false,
                registeredCountry: 0,   // 注册地
                taxpayerType: 0,        // 纳税人类型
                deptId:0,               // 部门id
                categoryType: [],
                brandDetail: {
                    registeredCountry: 1,
                    brandName: "",
                    brandEnname: "",
                    categories: [],
                    goodsType: 1,
                    businessType: 1,
                    trademarkRegistrationCertificateFiles: [],
                    authCertificateFiles: [],
                    qualityInspectionFiles: [],
                    qualityInspectionTime: 0
                }
            }
        },
        mounted () {
            var agreementBrandId = this.$route.query.agreementBrandId;
            this.initBrandDetail(agreementBrandId);
        },
        methods: {
            initBrandDetail(agreementBrandId){
                var that = this;
                $.get({
                    url: '/suppliers/brandAgreement/agreementBrand/find',
                    data: {
                        agreementBrandId: agreementBrandId
                    },
                    success: function (result) {
                        if (!result.code) {
                            that.brandDetail = result.data;
                            that.registeredCountry = result.data.registeredCountry;
                            that.taxpayerType = result.data.taxpayerType;
                            that.deptId = result.data.deptId;
                            that.brandDetail.categoryIsBook = result.data.categoryIsBook;
                            that.brandDetail.categoryNotBook = result.data.categoryNotBook;
                            if (that.brandDetail.categoryIsBook == 1 && that.brandDetail.categoryNotBook == 1) {
                                that.categoryType = ["1","2"]
                            } else if (that.brandDetail.categoryIsBook == 1 && that.brandDetail.categoryNotBook == 0) {
                                that.categoryType = ["1"]
                            } else if (that.brandDetail.categoryIsBook == 0 && that.brandDetail.categoryNotBook == 1) {
                                that.categoryType = ["2"]
                            }
                        } else {
                            that.$message({
                                showClose: true,
                                message: result.msg,
                                type: 'error'
                            });
                        }
                    }
                })
            },
            reback(){
                window.close();
            },
            // 预览图片
            previewPic (e) {
                console.log(e)
                this.dialogVisible = true;
                // 获取当前图片地址
                this.dialogImageUrl = e.currentTarget.src;
            }
        },
        computed: {
//			amount: function () {
//				return 200 - this.addForm.brandDesc.length;
//			}
        }
    }

</script>

<style type="text/css" lang="less" scoped>
    .edit_wrap {
        width: 1050px;
        // height: 4000px;
        margin: 50px auto;
        border: 1px solid #eee;
        .add_top {
            width: 100%;
            height: 40px;
            background-color: #f9f9f9;
        }
        .add_tab {
            display: inline-block;
            width: 170px;
            height: 40px;
            text-align: center;
            line-height: 40px;
            color: #666;
            font-size: 14px;
            cursor: pointer;
        }
        .active_tab {
            border-bottom: 1px solid #ff4a7d;
            color: #ff4a7d;
        }
        .add_name {
            padding-left: 96px;
        }
    }

    .choice_brand {
        min-height: 400px;
    }

    .w500 {
        width: 500px;
    }

    .w250 {
        width: 250px;
    }

    .w165 {
        width: 165px;
    }

    .radio_group {
        width: 90%;
        padding-left: 15%;
        max-height: 150px;
        overflow-y: scroll;
    }

    .list_radio {
        margin-top: 10px;
        margin-left: 10%;
        width: 40%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .mt120 {
        margin-top: 120px;
    }

    .result_radio .el-radio + .el-radio {
        margin-left: 10%;
    }

    .dialog-footer {
        text-align: center;
    }

    .form_color {
        color: rgb(106, 72, 77);
    }

    .c_name, .e_name {
        line-height: 36px;
    }

    .el-form-item {
        margin-bottom: 0;
    }

    .pic_skan {
        width: 150px;
        height: 150px;
        margin-top: 5px;
        border: 1px solid #c0ccda;
        border-radius: 6px;
        box-sizing: border-box;
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// brandDetail.vue?540b9f57